import React from "react";

interface DelegationContactInfoProps {
  formData: {
    receivingUnit: string;
    purpose: string;
    otherPurpose: string;
    basis: string;
    notes: string;
  };
  handleInputChange: (field: string, value: string) => void;
}

const DelegationContactInfo: React.FC<DelegationContactInfoProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className=" p-4 rounded-lg">
      {/* First Row - Three Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
        {/* Đơn vị tiếp đón */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Đơn vị tiếp đón <span className="text-red-500">(*)</span>
          </label>
          <select
            value={formData.receivingUnit}
            onChange={(e) => handleInputChange("receivingUnit", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Đơn vị tiếp đón -</option>
            <option value="department-1">Phòng Hợp tác Quốc tế</option>
            <option value="department-2">Phòng Đào tạo</option>
            <option value="department-3">Phòng Nghiên cứu</option>
            <option value="department-4">Phòng Quản lý Khoa học</option>
            <option value="department-5">Phòng Tổ chức Cán bộ</option>
          </select>
        </div>

        {/* Mục đích vào */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Mục đích vào <span className="text-red-500">(*)</span>
          </label>
          <select
            value={formData.purpose}
            onChange={(e) => handleInputChange("purpose", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Mục đích vào -</option>
            <option value="research">Nghiên cứu</option>
            <option value="training">Đào tạo</option>
            <option value="conference">Hội thảo</option>
            <option value="cooperation">Hợp tác</option>
            <option value="visit">Thăm quan</option>
            <option value="other">Khác</option>
          </select>
        </div>

        {/* Mục đích khác */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Mục đích khác
          </label>
          <input
            type="text"
            value={formData.otherPurpose}
            onChange={(e) => handleInputChange("otherPurpose", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Mục đích khác"
          />
        </div>
      </div>

      {/* Second Row - Full Width for Căn cứ */}
      <div className="mb-4">
        {/* Căn cứ */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Căn cứ
          </label>
          <input
            type="text"
            value={formData.basis}
            onChange={(e) => handleInputChange("basis", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nhập tên file các quyết định, kế hoạch được phê duyệt"
          />
        </div>
      </div>

      {/* Third Row - Full Width for Ghi chú */}
      <div className="mb-4">
        {/* Ghi chú */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ghi chú
          </label>
          <textarea
            value={formData.notes}
            onChange={(e) => handleInputChange("notes", e.target.value)}
            rows={4}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ghi chú..."
          />
        </div>
      </div>
    </div>
  );
};

export default DelegationContactInfo;
